import { loadStripe } from "@stripe/stripe-js";
import { REACT_PK } from "../../config";
import { confirmAccountShopPayment } from "../auth/apiShops";

let stripePromise = null;
const getStripe = () => {
  if (!REACT_PK) return Promise.resolve(null);
  if (!stripePromise) stripePromise = loadStripe(REACT_PK);
  return stripePromise;
};

// Paid creation needing 3-D Secure: the boutique is created by the server only
// after it re-reads the confirmed PaymentIntent (never on the client's word).
export const completeShopPayment = async (shopId, payment) => {
  if (!payment?.requiresAction || !payment?.clientSecret) return { payment };
  const stripe = await getStripe();
  if (!stripe) throw new Error("The payment could not be completed here. Please try again later.");
  const confirmation = await stripe.confirmCardPayment(
    payment.clientSecret,
    payment.paymentMethodId ? { payment_method: payment.paymentMethodId } : undefined
  );
  if (confirmation.error) throw new Error(confirmation.error.message);
  return confirmAccountShopPayment(shopId, payment.paymentIntentId);
};
